<h1 *ngIf="!data.name" mat-dialog-title>{{ 'settings.refresh-audits-label' | translate }}</h1>
<h1 *ngIf="data.name" mat-dialog-title>{{data.name}}</h1>

<mat-dialog-content>
  <mat-progress-bar [mode]="downloadService.progress === 0 ? 'indeterminate' : 'determinate'" [value]="downloadService.progress"></mat-progress-bar>
  <p class="help-text">
    Updating, thank you for your patience.
  </p>
</mat-dialog-content>
